'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TopComponent = require('../../components/top/TopComponent.vue');

var _TopComponent2 = _interopRequireDefault(_TopComponent);

var _HeroComponent = require('../../components/hero/HeroComponent.vue');

var _HeroComponent2 = _interopRequireDefault(_HeroComponent);

var _InfosComponent = require('../../components/infos/InfosComponent.vue');

var _InfosComponent2 = _interopRequireDefault(_InfosComponent);

var _SliderComponent = require('../../components/slider/SliderComponent.vue');

var _SliderComponent2 = _interopRequireDefault(_SliderComponent);

var _GoogleMapComponent = require('../../components/google-map/GoogleMapComponent.vue');

var _GoogleMapComponent2 = _interopRequireDefault(_GoogleMapComponent);

var _TimelapseComponent = require('../../components/timelapse/TimelapseComponent.vue');

var _TimelapseComponent2 = _interopRequireDefault(_TimelapseComponent);

var _AdditionalInfosComponent = require('../../components/additional-infos/AdditionalInfosComponent.vue');

var _AdditionalInfosComponent2 = _interopRequireDefault(_AdditionalInfosComponent);

var _InterviewComponent = require('../../components/interview/InterviewComponent.vue');

var _InterviewComponent2 = _interopRequireDefault(_InterviewComponent);

var _SelectMenuComponent = require('../../components/select-menu/SelectMenuComponent.vue');

var _SelectMenuComponent2 = _interopRequireDefault(_SelectMenuComponent);

var _BottomComponent = require('../../components/bottom/BottomComponent.vue');

var _BottomComponent2 = _interopRequireDefault(_BottomComponent);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    mounted: function mounted() {
        setTimeout(function () {
            AOS.init({
                disable: 'mobile'
            });
        }, 800);
    },


    computed: {
        isShop: function isShop() {
            return window.GLOBAL_CONFIG.isShop;
        }
    },

    asyncComputed: {

        dico: function dico() {
            var url = window.GLOBAL_CONFIG.centralDicoUrl;
            url = url.replace("MM", window.GLOBAL_CONFIG.market);
            url = url.replace("LL", window.GLOBAL_CONFIG.lang.toUpperCase());

            return _axios2.default.get(url).then(function (response) {
                var centralDico = response.data;
                var dico = window.GLOBAL_CONFIG.dico;

                if (centralDico['title']) dico['generic_content']['title'] = centralDico['title'];

                if (centralDico['gc-disclaimer']) dico['generic_content']['gc_disclaimer'] = centralDico['gc-disclaimer'];

                if (centralDico['kakaxi-disclaimer']) dico['generic_content']['kakaxi_disclaimer'] = centralDico['kakaxi-disclaimer'];

                if (centralDico['monthly-title']) dico['generic_content']['monthly_title'] = centralDico['monthly-title'];

                if (centralDico['monthly-pitch']) dico['generic_content']['monthly_pitch'] = centralDico['monthly-pitch'];

                if (centralDico['insta-bloc-title']) dico['generic_content']['insta_bloc_title'] = centralDico['insta-bloc-title'];

                if (centralDico['detail-bloc-title']) dico['generic_content']['detail_bloc_title'] = centralDico['detail-bloc-title'];

                if (centralDico['ra-disclaimer']) dico['generic_content']['ra_disclaimer'] = centralDico['ra-disclaimer'];

                if (centralDico['navigation-title']) dico['generic_content']['navigation_title'] = centralDico['navigation-title'];

                if (centralDico['farms']) {
                    _lodash2.default.each(centralDico['farms'], function (farm) {
                        if (farm['intro-farmer']) dico['farms'][farm['id']]['intro_farmer'] = farm['intro-farmer'];
                        if (farm['interview-title']) dico['farms'][farm['id']]['interview_title'] = farm['interview-title'];
                        if (farm['interview1']) dico['farms'][farm['id']]['interview1'] = farm['interview1'];
                        if (farm['interview2']) dico['farms'][farm['id']]['interview2'] = farm['interview2'];
                    });
                }

                return dico;
            }).catch(function (error) {
                return window.GLOBAL_CONFIG.dico;
            });
        },

        currentFarm: function currentFarm() {
            $(".farm-page, .farm-page__line2, .farm-page__line3, .farm-page__line4").removeClass("aos-init aos-animate");
            return _axios2.default.get(window.GLOBAL_CONFIG.baseApiUrl + "/farm/" + this.$route.params.slug).then(function (response) {
                if (response.status === 200 && response.data.data) {
                    setTimeout(function () {
                        return AOS.refresh();
                    }, 600);
                    setTimeout(function () {
                        return $(window).trigger("ccf:loaded");
                    }, 600);
                    var farmId = response.data.data.dico['id'];
                    if (farmId && window.GLOBAL_CONFIG.dico.farms[farmId]) response.data.data.dico = window.GLOBAL_CONFIG.dico.farms[farmId];
                    return response.data.data;
                }
            });
        }

    },

    components: {
        Top: _TopComponent2.default, Hero: _HeroComponent2.default, SelectMenu: _SelectMenuComponent2.default, Infos: _InfosComponent2.default, Slider: _SliderComponent2.default, GoogleMap: _GoogleMapComponent2.default, Timelaps: _TimelapseComponent2.default, AdditionalInfos: _AdditionalInfosComponent2.default, Interview: _InterviewComponent2.default, Bottom: _BottomComponent2.default
    }

};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/pages/farm/FarmPage.vue
// module id = 407
// module chunks = 0